var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2eee466dbb269927f367d0d3688fc5cc8355bf9e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["adid-festival@last-rev-llc"]={id:"2eee466dbb269927f367d0d3688fc5cc8355bf9e"};
      